module.exports = __webpack_public_path__ + "static/media/delete.84cee61c.svg";